/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'
import Auth from '../auth/auth'
import Router from '../router'

import { FOOSHI_API_URL } from '../.env'

export class Http {
  constructor (status) {
    this.isAuth = status && status.auth ? status.auth : false
    this.instance = axios.create({
      baseURL: FOOSHI_API_URL
    })

    return this.init()
  }

  init () {
    if (this.isAuth) {
      // middleware to handle Unauthorized requests
      this.instance.interceptors.response.use(response => {
        // do nothing when http status is !== 401
        return response
      }, error => {
        if (error.response.status === 401) {
          // log out from our auth instance
          Auth.getInstance().logout()

          // redirect to login page in case of unauthorized requests
          Router.push('/login')
        }
        return Promise.reject(error)
      })
      this.instance.interceptors.request.use(config => {
        config.headers.common.Authorization = `${Auth.getInstance().getToken()}`
        return config
      }, error => {
        return Promise.reject(error)
      })
    }

    return this.instance
  }
}



// WEBPACK FOOTER //
// ./src/services/http.init.js